import { Notification } from '@app/components/various/Notification';
import { Skeleton } from '@app/components/various/Skeleton';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Cms } from '@typings';
import { useTranslation } from 'react-i18next';

import { PreviewListItem } from '../PreviewListItem';

interface Props {
  isLoading?: boolean;
  selectedSlug: Nullable<string>;
  selectedPages: Cms.Page[];
}

export const HomePagePreview = ({ isLoading, selectedSlug, selectedPages }: Props) => {
  const { t } = useTranslation(['settings']);

  if (isLoading) {
    return (
      <div className="min-h-16 rounded-regular">
        <Skeleton type="rectangle" className="min-h-12" />
      </div>
    );
  }

  if (!isDefined(selectedSlug)) {
    return <Notification type="info" message={t('settings:no_page_selected')} />;
  }

  if (isEmpty(selectedPages)) {
    return <Notification type="error" message={t('settings:no_published_page')} />;
  }

  return (
    <div className="flex min-h-16 flex-col gap-2 rounded-regular">
      {selectedPages.map(page => (
        <PreviewListItem key={`preview-${page.id}`} name={page.name} slug={page.slug} id={page.id} markets={page.markets} />
      ))}
    </div>
  );
};
